import React, { Component, useEffect, useState } from "react";
import { NotificationFrequency } from "../../../../../../models/enums";
import { DropdownSelect } from "../../../../../../components/FormControls";

import styles from "./notificationSelector.scss";

interface NotificationSelectorProps {
  value: string;
  onChange: ({}) => void;
}

const FIELD_NAME = "frequency";

const NotificationSelector = (props: NotificationSelectorProps) => {
  const { value } = props;

  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    if (value && value != selectedValue) {
      setSelectedValue(value);
    }
  }, [value]);

  const handleChange = value => {
    const { onChange } = props;

    setSelectedValue(value[FIELD_NAME]);
    onChange(value[FIELD_NAME]);
  };

  const options = NotificationFrequency.map(({ name, value }) => ({
    title: name,
    value
  }));
  const menuValue = { [FIELD_NAME]: selectedValue };

  return (
    <div className={styles.container}>
      <DropdownSelect
        options={options}
        field={FIELD_NAME}
        value={menuValue}
        onChange={handleChange}
        title={"Razdoblje obavijesti"}
      />
    </div>
  );
};

NotificationSelector.defaultProps = {
  onChange: () => null
};

export default NotificationSelector;



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/ListSavedSearch/ListSavedSearchMobile/SavedSearchItem/NotificationSelector/index.tsx